<template>
  <div class="pano_txt_box" @click.stop="">
    <div class="close-btn" @click.stop="closeDialog"></div>

    <div class="pano_txt_box_top">
      <div class="pano_txt_box_top_left" v-if="modelArray[activeIndex]">
        <h2>{{modelArray[activeIndex].name.split('#')[0]}}</h2>
        <div class="pano_txt_box_left_container">
          <vue-scroll>
            <div class="text" v-html="util.fixIntro(modelArray[activeIndex].properties.content)"></div>
          </vue-scroll>
        </div>
      </div>

      <!-- 之后是三维模型 -->
      <div class="pano_txt_box_top_right">
        <div id="model3d" ref="model3d"></div>
      </div>
    </div>

    <div class="pano_txt_box_bottom">
      <div class="pano_txt_box_bottom_tabs">
        <span v-for="(item, index) in modelGroupArray" :key="index" :class="{'tabs_active': item.name === modelArray[activeIndex].linkName}" @click.stop="switchActive(0)">{{item.name}}</span>
      </div>

      <div class="pano_txt_box_bottom_swiper">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :class="{'selected': index === activeIndex}" v-for="(model, index) in modelArray" :key="index" @click.stop="switchActive(index)">
              <img :src="model.properties.modelInfo.thumbnail" alt="">
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'panoTextSwiper',
  props: {
    pluginJson: {
      type: Object,
      default: function () {
        return null
      }
    },
    pluginIndex: {
      type: String
    }
  },
  data () {
    return {
      activeIndex: 0,
      modelArray: [],
      modelGroupArray: [],
      modelGroupOption: {}
    }
  },
  watch: {

  },
  mounted () {
    this.initEngine()
    this.$api.getPanoMarker({ facilityId: this.pluginJson.id, materialId: this.pluginJson.pano[0].materialId }).then((res) => {
      this.activeIndex = Number(this.pluginIndex) - 1
      this.formatList(res.data.data.marker)
    })
  },
  methods: {
    initEngine () {
      // 初始化全景实例
      window.model = new window.vizengine.Model3DView(document.querySelector('#model3d'))
      window.model.setAlpha(0)
      window.model.setAutoPlayLoopTime(100000)
    },
    setModel (modelInfo, callback) {
      window.model.clear()
      let _modelInfo = JSON.parse(JSON.stringify(modelInfo))
      // _modelInfo.pose = this.pluginData.groupData(this.APPID).pose
      this.util.modelSetModelId(window.model, _modelInfo, () => {
        if (this.util.isIOS() || this.util.isAndroid()) {
          window.model.setLevelCount(1)
        } else {
          window.model.setLevelCount(2)
        }
        window.model.onModelLoadedCallback = () => { callback && callback() }
      })
    },
    formatList (array) {
      let newArray = array
      newArray.sort((a, b) => {
        return a.name.split('#')[1] - b.name.split('#')[1]
      })
      newArray.forEach((el, index) => {
        if (!this.modelGroupOption[el.linkName]) {
          let json = {}
          json['name'] = el.linkName
          json['index'] = index
          this.modelGroupArray.push(json)
          this.modelGroupOption[el.linkName] = 1
        }
      })
      this.modelArray = newArray
      console.log(newArray)

      let index = this.activeIndex
      this.$nextTick(() => {
        this.swiper = new window.Swiper('.swiper-container', {
          freeMode: true,
          slidesPerView: 'auto',
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next',
          onInit: function (swiper) {
            swiper.slideTo(index, 500, false)
          }
        })
      })

      this.setModel(this.modelArray[this.activeIndex].properties.modelInfo)
    },
    closeDialog () {
      this.$emit('closeDialog', 'threeSwiperShow')
    },
    switchActive (index) {
      if (this.activeIndex === index) {
        return
      }
      this.activeIndex = index
      this.setModel(this.modelArray[this.activeIndex].properties.modelInfo)
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }

  body {
    padding: 0;
    margin: 0;
  }
  .pano_txt_box {
    position: relative;
    width: rem(880);
    height: rem(570);
    margin: rem(100) auto;
    background: rgba(25, 35, 70, 0.85);
    box-shadow: 0px rem(12) rem(12) 0px rgba(30, 46, 79, 0.5);
    border-radius: rem(12);
    padding: rem(50) rem(40) rem(20) rem(40);
    border: 1px solid #FFE1BE;

    .pano_txt_box_top {
      width: 100%;
      height: rem(326);
      padding-left: rem(30);
      margin-bottom: rem(30);
      display: flex;

      .pano_txt_box_top_left {
        height: 100%;
        width: rem(280);
        margin-right: rem(60);

        h2 {
          font-size: rem(24);
          color: #FFE1BE;
          line-height: rem(28);
          margin-top: rem(30);
          margin-bottom: rem(30);
        }

        .pano_txt_box_left_container {
          font-size: rem(12);
          color: #FFE1BE;
          line-height: rem(20);
          height: rem(200);
          width: rem(260);
          padding-right: rem(10);

          .__vuescroll {
            padding-right: rem(10);
          }
          p{
            text-align: justify;
            text-indent: 2em;
          }
        }
      }

      .pano_txt_box_top_right {
        #model3d {
          width: rem(495);
          height: rem(325);
          outline: none;
        }
      }

    }

    .pano_txt_box_bottom {
      height: rem(150);
      width: rem(840);
      padding-left: rem(30);

      .pano_txt_box_bottom_tabs {
        height: rem(40);
        width: 100%;
        font-size: rem(16);
        line-height: rem(16);
        font-weight: 500;
        color: #fff;
        margin-bottom: rem(10);

        .tabs_active {
          color: #5F96FF;
          line-height: rem(30);
          border-bottom: 4px solid #5F96FF;

        }
        span {
          display: inline-block;
          margin-right: rem(20);

        }

      }

      .pano_txt_box_bottom_swiper {
        height: rem(110);
        width: 100%;

        .swiper-container {
          height: rem(130);
        }

        .swiper-wrapper {
          height: rem(130);
        }

        .swiper-slide {
          border-radius: rem(12);
          width: rem(155);
          height: rem(110);
          border: 1px solid rgba(0,0,0,0);
          margin-right: rem(10);
          overflow: hidden;
          img {
            width: rem(155);
            height: rem(110);
          }
          &.selected{
            border: 1px solid #5F96FF;
          }
        }

        .swiper-button-next {
          background-image : url('../assets/img/marker/pano_next.png');
          background-size: rem(20) rem(20);
          /*right: rem(90);*/
          top: 80%;
        }

        .swiper-button-prev {
          background-image : url('../assets/img/marker/pano_prev.png');
          background-size: rem(20) rem(20);
          left: rem(30);
          top: 80%;
        }
      }
    }

    .close-btn {
      position: absolute !important;
      right: rem(10) !important;
      top: rem(10) !important;
    }
  }

</style>
